<!--
 * @Description:
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-01-02 15:14:28
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<!--
Author: TangChen
Date: 2018-12-08
Desc: 基金赎回，由index.js 配置引入
-->
<template>
    <div>
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">
                    我的资产
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <div v-if="!shortProFlag">
            <sell></sell>
        </div>
        <div v-else>
            <el-tabs v-model="activeName">
                <el-tab-pane v-if="sellFlag" label="赎回" name="sell">
                    <sell v-if="activeName == 'sell'"></sell>
                </el-tab-pane>
                <el-tab-pane v-if="preSellFlag" label="预约赎回" name="preSell">
                    <preSell v-if="activeName == 'preSell'" :pre-sell-data="preSellData"></preSell>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import sell from "./sell.vue";
import preSell from "./preSell.vue";

export default {
    name: "SellFund",
    components: {
        sell,
        preSell
    },
    mixins: [mixin],
    data() {
        return {
            activeName: "sell",
            shortProFlag: false,
            sellFlag: false,
            preSellFlag: false,
            preSellData: {},
            fund: {}
        };
    },

    mounted() {
        this.$util.request("short/asset/detailDX", {fundcode: this.$route.query.fundcode}, "GET").then(res => {
            const resData = res.data;
            const detailData = [];
            resData.forEach(function (item) {
                if(item.preavailbal != 0){
                    item.newfrzfundvol = 0;
                    detailData.push(item);
                }
            });
            // 如果结果中数据为空，说明该产品不是短期理财产品
            if(resData.length == 0){
                this.shortProFlag = false;
            }else{
                this.shortProFlag = true;
                detailData.sort(function (a, b) {
                    return a.finaldate - b.finaldate; // 升序排列
                });

                const todayTime = this.$cache.getUser().busidate;

                this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
                if(this.fund.fundArr.length > 0){
                    let fundArr = Object.assign([],this.fund.fundArr);
                    let zx = [];
                    this.fund.fundArr = this.fund.fundArr.filter(fund => fund.paycenterid !== this.$util.getConfig().const.ZX_CENTER);
                    zx = fundArr.filter(fund => fund.paycenterid === this.$util.getConfig().const.ZX_CENTER);
                    zx.forEach(item => this.fund.fundArr.push(item));
                }
                this.fund.fundArr.forEach((item) => {
                    if(item.availablevol && item.availablevol > 0){
                        this.sellFlag = true;
                        this.activeName = "sell";
                    }
                });

                if(detailData[0] && detailData[detailData.length - 1].finaldate > todayTime){
                    this.preSellFlag = true;
                    if(!this.sellFlag){
                        this.activeName = "preSell";
                    }
                }
                // 创建一个空对象作为结果存放容器
                const preSellResult = {};
                const sellResult = {};
                // 遍历原始数组
                detailData.forEach(function (item) {
                    if(item.finaldate > todayTime){
                        // 获取交易账户字段值作为key
                        let key = item.transactionaccountid;
                        if (!preSellResult[key]) {
                            // 如果该key不存在于结果对象中，则初始化一个新的数组
                            preSellResult[key] = [];
                            item.newfrzfundvol = item.prefrozenfundvol * 1;
                            // 将当前项添加到对应交易账号的数组中
                            preSellResult[key].push(item);
                        }else{
                            let addFlag = false;
                            preSellResult[key].forEach((arrItem)=>{
                                if(arrItem.finaldate == item.finaldate){
                                    // 将支付账户和时间相同的数据的份额加到一起
                                    arrItem.preavailbal = arrItem.preavailbal * 1 + item.preavailbal * 1;
                                    arrItem.newfrzfundvol = arrItem.newfrzfundvol * 1 + item.prefrozenfundvol * 1;
                                    addFlag = true;
                                }
                            });
                            // 如果支付账户相同，时间不相同，那就不加到一起
                            if(!addFlag){
                                item.newfrzfundvol = item.prefrozenfundvol * 1;
                                preSellResult[key].push(item);
                            }
                        }
                    }
                });
                this.preSellData = preSellResult;
            }
        });
    },
    methods: {


    }
};
</script>
<style lang="scss">
</style>
